import React, { PureComponent } from 'react';
import _ from 'lodash'
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Table, Modal
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import './styles.css';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import XLSX from 'xlsx';
import { MDBDataTable } from 'mdbreact';
import * as FileSaver from 'file-saver';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import Util from '../../../Common/util';
import API from '../../../Common/api';

import './styles.css';
import LoadingOverlay from 'react-loading-overlay';
import styled, { css } from "styled-components";
import DatePicker from "react-datepicker";


const DarkBackground = styled.div`
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */

  ${(props) =>
    props.disappear &&
    css`
      display: block; /* show */
    `}
`;


var url = window.location.hostname;
var port = window.location.port;
var From_Date_val;
var to_Date_val;



const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const fileExtension = '.xlsx';

const exportToCSV = (csvData,fileName) => {
  // const ws = XLSX.utils.json_to_sheet(csvData);
  const Heading = [['Date',	'City',	'Warehouse',	'Brand',	'Item Code',	'Item Description','Mrp',	'From Location',	'To Location',	'Quantity',	'Mrp Value','Total Value','Transfer From', 'Transfer To',	'User Name',	'Reason'
]];
  const ws = XLSX.utils.json_to_sheet(csvData,{ origin: 'A2', skipHeader: true });
  XLSX.utils.sheet_add_aoa(ws, Heading, { origin: 'A1' });
  const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const data = new Blob([excelBuffer], {type: fileType});
  FileSaver.saveAs(data, fileName + fileExtension);
}


class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.createCookie = this.createCookie.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.fetchInventoryData = this.fetchInventoryData.bind(this);
    this.indexOfExt = this.indexOfExt.bind(this);
    this.processData = this.processData.bind(this);

    this.state = {
      loading_overlay: false,
      showPassword: false,
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      showInvalidItem: false,
      fileNameVal: 'masterFile',
      showRowDataError: false,
      invalidItemList: [],
      selectedOption: null,
      posts: [],
      ErrorRowData: [],
      loading: false,

      isLoading: true,
      showFetchBinData: true,
      show_process_data: true,

      from_date: "",
      to_date: "",

      tableRows: [],
      value: '',
      error: '',
      value: 'select',
      selectedFileType: '',
      orderData :[],
      warehouse_code:"",
      brand_code : "",
      city:"",
      clientData:[],
      warehouseData:[],
      cityData:[],


    };
  }


  showPassword = (e) => {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  };

  componentDidMount() {
    // this.fetchInventoryData();
      this.fetchBrandData();
      this.fetchWarehouseData();
      this.fetchCityData();
  }


  componentWillMount() {

    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090"
    } else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088"
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";

    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = this.getCookie('token');
    var location = this.getCookie('selectedLocation');
    var username = this.accessCookie("token");
    this.setState({
      userName: cookieUsername,
      selectedLocation: location
    })

    localStorage.setItem('userName', username);
  }

  createCookie(cookieName, cookieValue, daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime() + (1 * 24 * 60 * 60 * 1000));
    document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(';');
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  indexOfExt(list, item) {
    var len = list.length;

    for (var i = 0; i < len; i++) {
      var keys = Object.keys(list[i]);
      var flg = true;
      for (var j = 0; j < keys.length; j++) {
        var value = list[i][keys[j]];
        if (item[keys[j]] !== value) {
          flg = false;
        }
      }
      if (flg == true) {
        return i;
      }
    }
    return -1;
  }

  convertDate = (inputFormat) => {
    function pad(s) { return (s < 10) ? '0' + s : s; }
    var d = new Date(inputFormat)
    return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('-')
  }

  FromDateChange = date => {
    this.setState({
      from_date: date,
      showFromErr: false

    })
    if (date) {
      From_Date_val = this.convertDate(date);
    } else {
      this.setState({
        fromdate: ""
      })
      From_Date_val = ""
    }


  }

  ToDateChange = date => {

    this.setState({
      to_date: date,
      showToErr: false
    })
    if (date) {
      to_Date_val = this.convertDate(date);
    } else {
      this.setState({
        to_date: "",

      })
      to_Date_val = ""
    }

  }
  oncityChange = (evt) =>{

    this.setState({
      city : evt.target.value
    })

  }
  onwarehouseChange = (evt) =>{

    this.setState({
      warehouse_code : evt.target.value
    })

  }

  onBrandChange = (evt) =>{

    this.setState({
      brand_code : evt.target.value
    })

  }

  fetchCityData = () =>{

    const payload = {
      

    };

    API.post('/product/product_master/v1/city/dropdown/', { param: payload })

      .then((response) => response.data)
      .then((data) => {

        console.log(data)

        this.setState({
          //showFetchDispatchData: true,
          cityData: data.data,
          loading: false
        });

      })
      .catch(function (error) { });

  }

  fetchWarehouseData = () =>{

    const payload = {
      

    };

    API.post('/product/product_master/v1/warehouse/dropdown/', { param: payload })

      .then((response) => response.data)
      .then((data) => {

        console.log(data)

        this.setState({
          //showFetchDispatchData: true,
          warehouseData: data.data,
          loading: false
        });

      })
      .catch(function (error) { });

  }

  fetchBrandData = () =>{

    const payload = {
      

    };

    API.post('/product/product_master/v1/client/dropdown/', { param: payload })

      .then((response) => response.data)
      .then((data) => {

        console.log(data)

        this.setState({
          //showFetchDispatchData: true,
          clientData: data.data,
          loading: false
        });

      })
      .catch(function (error) { });

  }

  fetchInventoryData() {

    this.setState({
      showFetchBinData: true,
      showFetchBaseData: false,
      showFetchProductData: false,
      showFetchTesterData: false,
      loading_overlay: true
    })

    const payload = {
      location: this.state.selectedLocation,
      from_date: From_Date_val,
      to_date: to_Date_val,
      request_type: "view",
      brand_code : this.state.brand_code,
      warehouse_code : this.state.warehouse_code,
      city_code : this.state.city,
    };
    API.post('/stock/fetchBinToBinTransferData', { param: payload })
      .then(response => response.data)

      .then(data => {

        this.setState({
           tableRows: this.assemblePosts(data.data),
          //  orderData : data.data

        })

      })

      .then(async () => {

        this.setState({  isLoading: false })

       

      });
  }
  filterData = (evt) => {
    if (evt == "") {
      this.setState({ filtered_orderData: this.state.orderData});
    } else {
      
      var value = this.state.orderData.filter(
        (val) =>{
        return Object.keys(val).some(key =>{
          var data = ""
          if (val[key] == null ) {
            data = ""
          } 
          else {
            data = val[key]
          }
          
          return data.toString().toLowerCase().includes(evt.toLowerCase()) 
        })
        }
        );
      
        this.setState({
          filtered_orderData: value,
        });
      }
    };
  downloadReport = () => {
    //this.setState({loading:true})
    const payload = {
      location: this.state.selectedLocation,
      fromdate: From_Date_val,
      todate: to_Date_val,
      request_type: "download"
    };

    API.post('/stock/fetchBinToBinTransferData', { param: payload })
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          loading: false
        });

        window.location.href = data.data[0]
      })
      .catch(function (error) { });
  };

  assemblePosts = (data) => {

    let posts = data.map((post) => {
      var status = ""
      if (post.status == true) {
        status = "Active"
      } else { status = " Not Active" }
      return (

        {
          date : post.date,
          city : post.city,
          warehouse : post.warehouse,
          brand: post.brand,
          product_code: post.prod_code,
          product_name: post.prod_name,
          mrp : post.mrp,
          from_loc: post.from_loc,
          to_loc: post.to_loc,
          qty: post.qty,
          mrp_value : post.mrp_value,
          total_value : post.total_value,
          transfer_from :post.transfer_from,
          transfer_to: post.transfer_to,
          user: post.user,
          reason: post.reasons,
        }

      )

    });

    this.setState({
      loading_overlay: false,
      posts: posts ,
      filtered_orderData : posts,
      orderData : posts,
    })

    return posts;

  }

  processData() {

    this.setState({
      loading: true
    })

  }

  render() {


    const data = {

      columns: [
        {
          label: 'Date',
          field: 'date',
          sort: 'asc',
          width: 130,

        },
        {
          label: 'City',
          field: 'city',
          sort: 'asc',
          width: 120,

        },
        {
          label: 'Warehouse',
          field: 'warehouse',
          sort: 'asc',
          width: 140,

        },
        {
          label: 'Brand',
          field: 'brand',
          sort: 'asc',
          width: 120,

        },
        {
          label: 'Item Code',
          field: 'product_code',
          sort: 'asc',
          width: 130,

        },

        {
          label: 'Item Description',
          field: 'product_name',
          sort: 'asc',
          width: 180,

        },
        {
          label: 'MRP',
          field: 'mrp',
          width: 100,
          sort: 'asc',
        },
        {
          label: 'From Location',
          field: 'from_loc',
          width: 150,
          sort: 'asc',

        },

        {

          label: 'To Location',
          field: 'to_loc',
          width: 150,
          sort: 'asc',

        },

        {

          label: 'Qty',
          field: 'qty',
          width: 100,
          sort: 'asc',

        },

        {

          label: 'Mrp Value',
          field: 'mrp_value',
          width: 150,
          sort: 'asc',

        },

        {

          label: 'Total Value',
          field: 'total_value',
          width: 150,
          sort: 'asc',

        },

        {

          label: 'Transfer From Type',
          field: 'transfer_from',
          width: 150,
          sort: 'asc',

        },

        {

          label: 'Transfer To Type',
          field: 'transfer_to',
          width: 150,
          sort: 'asc',

        },

        {

          label: 'User Name',
          field: 'user',
          width: 150,
          sort: 'asc',

        },

        {

          label: 'Reason',
          field: 'reason',
          width: 150,
          sort: 'asc',

        },

      ],

      rows: this.state.tableRows,

    }
    return (
      <Col xl={12}>
        {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>

            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
        <Card>
        <CardBody style={{ paddingTop: 22, height: 80, marginTop : "-20px",paddingBottom: 0 }}>
          <form className="form" >

            <div style={{ width: '15%', marginBottom: '0px', float: 'left', marginRight: 5 }}>

              <DatePicker
                selected={this.state.from_date}
                onChange={this.FromDateChange}
                className="ledger_fromdate"
                placeholderText="From Date"
                format='yyyy-MM-dd'


              />

              {this.state.showFromErr &&
                <span style={{ color: 'red', fontSize: 11 }}>Please Select From Date</span>
              }
            </div>

            <div style={{ width: '15%', marginBottom: '0px', float: 'left', marginRight: 5 }}>
              <DatePicker
                selected={this.state.to_date}
                onChange={this.ToDateChange}
                className="ledger_todate"
                placeholderText="To Date"
              />
              {this.state.showToErr &&
                <span style={{ color: 'red', fontSize: 11 }}>Please Select To Date</span>
              }

            </div>
            <div
                style={{ width: '13%', marginBottom: '0px', float: 'left', marginRight: 20, }}
              >
                <div
                  className="form__form-group-field"

                >
               <select
                    className="form-control"
                    style={{ fontSize: 13,  width: 190 }}
                    onChange={this.oncityChange}
                  >
                    <option value="">Select City</option>
                    {
                      this.state.cityData.length > 0 &&
                      this.state.cityData.map((cityData) => {
                        return (
                          <option value={cityData.name}>{cityData.name} </option>
                        );
                      })}
                  </select>
                  </div>
                  </div>
            <div
                style={{ width: '13%', marginBottom: '0px', float: 'left', marginRight: 20, }}
              >
                <div
                  className="form__form-group-field"

                >
               <select
                    className="form-control"
                    style={{ fontSize: 13,  width: 190 }}
                    onChange={this.onwarehouseChange}
                  >
                    <option value="">Select warehouse</option>
                    {
                      this.state.warehouseData.length > 0 &&
                      this.state.warehouseData.map((warehouseData) => {
                        return (
                          <option value={warehouseData.name}>{warehouseData.name} </option>
                        );
                      })}
                  </select>
                  </div>
                  </div>

                    <div
                style={{ width: '13%', marginBottom: '0px', float: 'left', marginRight: 20, }}
              >
                <div
                  className="form__form-group-field"

                >
               <select
                    className="form-control"
                    style={{ fontSize: 13,  width: 190 }}
                    onChange={this.onBrandChange}
                  >
                    <option value="">Select Brand</option>
                    {
                      this.state.clientData.length > 0 &&
                      this.state.clientData.map((clientData) => {
                        return (
                          <option value={clientData.name}>{clientData.name} </option>
                        );
                      })}
                  </select>
                  </div>
                  </div>

            <div style={{ width: '9%', marginBottom: '0px', marginLeft: "60px", float: 'left' }}>
              <ButtonToolbar className="form__button-toolbar">
                <Button
                  className="btn-sm button_enable "
                  style={{
                    fontWeight: "normal",
                    textTransform: "capitalize",
                    borderRadius: 5,
                    backgroundColor: "#70bbfd",
                    color: "#fff",
                    padding: "5px 25px",
                    fontSize: "14px",
                  }}
                  id="button_enable"
                  onClick={() => this.fetchInventoryData()}
                >
                  {this.state.loading && (
                    <i
                      className="fa fa-refresh fa-spin"
                      style={{ marginRight: "5px" }}
                    />
                  )}
                  View
                </Button>
              </ButtonToolbar>
            </div>
            <div style={{ width: '6%', marginBottom: '0px', float: 'left' }}>
              <Button type="button" className="btn btn-primary-outline"
                style={{
                  cursor: this.state.btnDisabled ? 'pointer' : 'pointer',
                  backgroundColor: this.state.btnDisabled ? '#FFFFFF' : '#FFFFFF',
                }}
                id="button_enable"
                // onClick={this.downloadReport}
              >

                {/* <img src={require('../../../../images/download.png')} onClick={this.state.downloadError} /> */}
                <img src={require('../../../../images/download.png')} onClick={(e) => exportToCSV(this.state.filtered_orderData, "Bin To Bin Transfer Report")} />
              </Button>
            </div>

          </form>
          </CardBody>
          {
            this.state.showFetchBinData && (

              <CardBody style={{ marginTop: 5 }}>
                <div className="table_header" style={{ borderBottomWidth: '0px' }}>

                  <h4 style={{ fontWeight: 'bold', width: '80%', paddingTop: 10, float: 'left' }} className="subhead red-text">Reports</h4>

                </div>
                <hr style={{ marginTop: '30px', marginBottom: '0px' }} />
                <MDBDataTable
                  striped
                  bordered
                  scrollX
                  // scrollY
                  sortable={false}
                  hover
                  onSearch={this.filterData}
                  data={data}
                  
                />
              </CardBody>

            )}

        </Card>

      </Col>
    );
  }
}

export default reduxForm({
  form: 'Upload Master', // a unique identifier for this form
})(withTranslation('common')(HorizontalForm));